import React, { type SVGProps } from "react";

type LucideIconProps = SVGProps<SVGSVGElement> & {
  /** 与设计稿 lucide 默认尺寸对齐 */
  size?: number;
};

const base = (props: LucideIconProps) => {
  const { size = 24, width, height, strokeWidth = 2, ...rest } = props;
  return {
    width: width ?? size,
    height: height ?? size,
    viewBox: "0 0 24 24",
    fill: "none" as const,
    stroke: "currentColor",
    strokeWidth,
    strokeLinecap: "round" as const,
    strokeLinejoin: "round" as const,
    ...rest,
  };
};

/** 对应设计稿 data-lucide="plane" */
export function LucidePlaneIcon(props: LucideIconProps) {
  const p = base(props);
  return (
    <svg {...p} aria-hidden>
      <path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z" />
    </svg>
  );
}

/** 对应设计稿 data-lucide="download" */
export function LucideDownloadIcon(props: LucideIconProps) {
  const p = base(props);
  return (
    <svg {...p} aria-hidden>
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="7 10 12 15 17 10" />
      <line x1="12" x2="12" y1="15" y2="3" />
    </svg>
  );
}

/** 对应设计稿 data-lucide="trash-2" */
export function LucideTrash2Icon(props: LucideIconProps) {
  const p = base(props);
  return (
    <svg {...p} aria-hidden>
      <path d="M3 6h18" />
      <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
      <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
      <line x1="10" x2="10" y1="11" y2="17" />
      <line x1="14" x2="14" y1="11" y2="17" />
    </svg>
  );
}
